// @flow
import get from 'lodash/get';
import type { ProductsQuery, ProductsFilters } from '../../types';
import mapBoolean from './mapBoolean';

function mapFilters(filters): ProductsFilters {
  return {
    region: filters.region,
    city: filters.city,
    priceMin: filters.price_min,
    priceMax: filters.price_max,
    photos: mapBoolean(filters.photos),
    decreasePrice: mapBoolean(filters.decrease_price),
  };
}

export default function(apiSearchNotification: Object): ProductsQuery {
  const categoryTypeId = get(
    apiSearchNotification,
    'attributes.query.vertical_properties.category_type_id'
  );
  const filters = get(apiSearchNotification, 'attributes.query.filters', {});

  return {
    search: get(apiSearchNotification, 'attributes.query.what', ''),
    verticalProperties: {
      categoryTypeId,
    },
    filters: mapFilters(filters),
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/shared/SearchNotifications/adapters/subscriptionQueryMapper/productsQueryMapper.js